define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 波纹编辑模式。
     *
     * @exports EnumRippleModulationMode
     * 
     * @see Ripple#modulationMode
     */
    var EnumRippleModulationMode = {
        /**
         * 扩散。
         * @type {Number}
         * @constant
         */
        EXPANSION: 0,

        /**
         * 收缩。
         * @type {Number}
         * @constant
         */
        CONTRACTION: 1
    }
    freezeObject(EnumRippleModulationMode)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumRippleModulationMode) {
            if (EnumRippleModulationMode.hasOwnProperty(key) && EnumRippleModulationMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        EXPANSION: 0,
        CONTRACTION: 1,
        getName: getName
    }
})